import { render } from "./LicenseWorkflowEditorCard.vue?vue&type=template&id=1234a07a"
import script from "./LicenseWorkflowEditorCard.vue?vue&type=script&lang=js"
export * from "./LicenseWorkflowEditorCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__